// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MoreVertical = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MoreVertical = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var MoreVertical = _exports.MoreVertical = function MoreVertical(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14623)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 5.625C11.0363 5.625 11.875 4.7814 11.875 3.74688C11.875 2.71235 11.0363 1.875 10 1.875C8.96375 1.875 8.125 2.71235 8.125 3.74688V3.75937C8.125 4.79264 8.96375 5.625 10 5.625Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 11.875C11.0363 11.875 11.875 11.0314 11.875 9.99688C11.875 8.96235 11.0363 8.125 10 8.125C8.96375 8.125 8.125 8.96235 8.125 9.99688V10.0094C8.125 11.0426 8.96375 11.875 10 11.875Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 18.125C11.0363 18.125 11.875 17.2814 11.875 16.2469C11.875 15.2124 11.0363 14.375 10 14.375C8.96375 14.375 8.125 15.2124 8.125 16.2469V16.2594C8.125 17.2926 8.96375 18.125 10 18.125Z",
      fill: "currentColor"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14623"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "17.5",
      height: "20",
      fill: "currentColor",
      transform: "translate(20 1.25) rotate(90)"
    }))));
  };
});
